module.exports = __webpack_public_path__ + "img/404-red.2dc6d1f6.svg";